import React from 'react';
import {
  Field,
  useField,
} from 'formik';

import FormField from './FormField.jsx';

const FormSelectableField = ({
  checkbox,
  radio,
  ...props
}) => {
  const f = radio || checkbox;
  const [, { error, touched }] = useField(f.name);

  const c = [
    'input-group-text',
    error && touched ? 'is-invalid' : '',
  ];

  const className = c.filter((s) => s).join(' ');

  return (
    <div className="input-group">
      <div className="input-group-prepend">
        <div className={className}>
          <Field
            type={checkbox ? 'checkbox' : 'radio'}
            {...f}
          />
        </div>
      </div>
      <FormField {...props} />
    </div>
  );
};

export default FormSelectableField;
